import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';

function Equipments() {
  const [equipments, setEquipments] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);

  const columns = [
    {
      title: 'Equipamento',
      field: 'name',
      hideFilterIcon: true,
    },
    {
      title: 'Tipo',
      field: 'type',
      hideFilterIcon: true,
    },
    {
      title: 'Consumo estimado (em kWh)',
      field: 'energyConsumption',
      hideFilterIcon: true,
    },
    {
      title: 'Descrição',
      field: 'description',
      hideFilterIcon: true,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/equipments');
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setEquipments(response.data);
        }
      } catch (err) {

      }
    }
    loadData();
  }, []);

  function setData(newData) {
    const tempData = [];
    equipments.map((equipments) => (equipments.id === newData.id
      ? tempData.push(newData)
      : tempData.push(equipments)));
    setEquipments(tempData);
  }

  return (
    <Table
      title="Controle de Equipamento"
      route="/equipments/"
      routeAdd="/equipment/"
      columns={columns}
      data={equipments}
      setData={setData}
      dataLoaded={openProgress}
    />
  );
}

export default Equipments;
